import { useCallback, useMemo, useState } from 'react';
import { EventListParams } from '../api/events';

export interface EventsFiltersState {
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  apartmentName: string;
  carNumber: string;
}

const EMPTY: EventsFiltersState = {
  startDate: '',
  startTime: '',
  endDate: '',
  endTime: '',
  apartmentName: '',
  carNumber: '',
};

const combine = (date: string, time: string, fallbackTime: string): string | undefined => {
  if (!date) return undefined;
  return `${date}T${time || fallbackTime}:00+09:00`;
};

export const useEventsFilters = () => {
  const [filters, setFilters] = useState<EventsFiltersState>(EMPTY);

  const update = useCallback(<K extends keyof EventsFiltersState>(key: K, value: EventsFiltersState[K]) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  }, []);

  const reset = useCallback(() => setFilters(EMPTY), []);

  const apiParams: EventListParams = useMemo(() => ({
    start_date: combine(filters.startDate, filters.startTime, '00:00'),
    end_date: combine(filters.endDate, filters.endTime, '23:59'),
    apartment_name: filters.apartmentName.trim() || undefined,
    car_number: filters.carNumber.trim() || undefined,
  }), [filters]);

  return { filters, update, reset, apiParams };
};
